import { useTranslation } from 'react-i18next';

type SideBarConfig = {
  heading: string;
  links: Link[];
};

type Link = {
  text: string;
  url: string;
};

export const useSideBarConfig = (marketCode?: string): SideBarConfig => {
  const { t } = useTranslation();
  switch (marketCode) {
    case 'US':
    case 'CA':
      return {
        heading: t('sidebar.heading.resourcesForYourCharity'),
        links: [
          {
            text: t('sidebar.helpUsImproveGC'),
            url: 'https://bb-justgiving.ideas.aha.io/ideas/new',
          },
          {
            text: t('sidebar.gettingStarted'),
            url: 'https://community.blackbaud.com/blogs/65',
          },
          {
            text: t('sidebar.tipsAndTricks'),
            url: 'https://community.blackbaud.com/blogs/84',
          },
          {
            text: t('sidebar.helpCentre'),
            url: 'https://justgiving-charity-support.zendesk.com/hc/en-us',
          },
          {
            text: t('sidebar.onDemandWebinars'),
            url: 'https://hello.blackbaud.com/CustomerSuccess-Blackbaud-P2P-JustGiving.html',
          },
        ],
      };
    case 'AU':
    case 'NZ':
      return {
        heading: t('sidebar.heading.resourcesForYourCharity'),
        links: [
          {
            text: t('sidebar.helpUsImproveGC'),
            url: 'https://bb-justgiving.ideas.aha.io/ideas/new',
          },
          {
            text: t('sidebar.resources'),
            url: 'https://resourcehub.blackbaud.com.au/peer-to-peer-fundraising',
          },
          {
            text: t('sidebar.helpCentre'),
            url: 'https://justgiving-charity-support.zendesk.com/hc/en-us',
          },
          {
            text: t('sidebar.askQuestion'),
            url: 'https://help.justgiving.com/hc/en-us/requests/new?ticket_form_id=8991',
          },
        ],
      };
    default:
      return {
        heading: t('sidebar.heading.supportForYourCharity'),
        links: [
          {
            text: t('sidebar.helpUsImproveGC'),
            url: 'https://bb-justgiving.ideas.aha.io/ideas/new',
          },
          {
            text: t('sidebar.resourcesHub'),
            url: 'https://www.justgiving.com/for-charities/resources',
          },
          {
            text: t('sidebar.faqs'),
            url: 'https://justgiving-charity-support.zendesk.com/hc/en-us',
          },
          {
            text: t('sidebar.askQuestion'),
            url: 'https://help.justgiving.com/hc/en-us/requests/new?ticket_form_id=8991',
          },
        ],
      };
  }
};
